<ul class="pl-4">
  <li *ngFor="let category of categories" class="mb-2">
    <div class="flex items-center space-x-2 cursor-pointer"
         (click)="onSelectCategory(category)">

      <!-- Expand/Collapse -->
      <button *ngIf="category.children && (category.children?.length ?? 0) > 0"
              (click)="toggleExpand(category); $event.stopPropagation()"
              class="text-gray-600 focus:outline-none">
        <span *ngIf="!category.expanded">➕</span>
        <span *ngIf="category.expanded">➖</span>
      </button>

      <!-- Category Name -->
      <span class="hover:text-blue-600">{{ category.name }}</span>
    </div>

    <!-- Recursive Children -->
    <div *ngIf="category.expanded && (category.children?.length ?? 0) > 0">
      <app-category-sidebar [categories]="category.children"
                            (categorySelected)="categorySelected.emit($event)">
      </app-category-sidebar>
    </div>
  </li>
</ul>
